import type { FC } from "react";
import { MouseEvent } from "react";

import { t } from "i18n/i18n";
import { DeleteReferenceKeys } from "i18n/i18next";
import { SquareIconButton, SquareIconButtonSize } from "mds/components/buttons/SquareIconButton";
import { TrashDeleteIcon } from "mds/icons";

export interface DeleteIconButtonProps {
  className?: string;
  onClick: () => void;
  reference: DeleteReferenceKeys;
  eventPrefix?: string;
  size?: SquareIconButtonSize;
}

// TODO: We have separate DeleteButtons that are similar, review and potentially combine abstractions.
export const ToolbarDeleteIconButton: FC<DeleteIconButtonProps> = ({
  className,
  onClick,
  eventPrefix,
  reference,
  size = "s",
}) => {
  return (
    <SquareIconButton
      aria-label={t("edit_delete_widget.delete", { context: reference })}
      className={className}
      eventName={eventPrefix ? `${eventPrefix}Delete` : undefined}
      kind="caution"
      size={size}
      onClick={(e: MouseEvent) => {
        e.stopPropagation();
        e.preventDefault();
        onClick();
      }}
    >
      <TrashDeleteIcon />
    </SquareIconButton>
  );
};
